import React, {useState} from "react";
import t, {changeLanguage} from "../../components/I18N/TranslateHelpers";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import ReCAPTCHA from 'react-google-recaptcha';
import {RootState} from "../../app/RootReducer";
import {UserDto} from "../Entity/User";
import {ContactFormData} from "./ContactFormType";
import {RECAPTCHA_PUBLIC_KEY} from "../../app/AppConfig";
import {GetCurrentLocale} from "../../components/Utils";
import {sendContactForm} from "../User/UsersSlice";

// Les propriétés du composant
type IDProps = {
  locale: string
}

const ContactForm : React.FC<IDProps> = (props: IDProps) => {
  const { register, handleSubmit, formState: { errors }, control } = useForm<ContactFormData>();
  const dispatch = useDispatch();
  const isAuth : boolean = useSelector((state: RootState) => state.userRdc.isAuthenticated);
  const userDetail : UserDto|null = useSelector((state: RootState) => state.userRdc.userDetail);
  const [recaptchaToken, setRecaptchaToken] = useState<string|null>(null);
  const success = useSelector((state: RootState) => state.userRdc.isRequestSuccess);
  const locale = GetCurrentLocale();
  changeLanguage(locale)
  const onSubmit = handleSubmit(({firstName,
                                   lastName,
                                   company,
                                   email,
                                   message,
                                   street,
                                   zipcode,
                                   city,
                                   country,
                                   jobFunction,
                                   phone,
                                   hasAcceptedConditions}) => {
    if(!recaptchaToken || recaptchaToken.length < 1)
    {
      console.log("reCAPTCHA not filled");
    }
    else
    {
      const urlOrigin = window.location.href.includes("?") ? window.location.href.slice(0, window.location.href.indexOf('?')) : window.location.href;

      let newContact : ContactFormData = {
        firstName, lastName, email, company, message, "g-recaptcha-response": recaptchaToken, locale: props.locale, urlOrigin: urlOrigin,
        street,
        zipcode,
        city,
        country,
        jobFunction,
        phone,
        hasAcceptedConditions: true
      };
      dispatch(sendContactForm(newContact, isAuth && userDetail ? userDetail.token : null));
    }
  });


  const recaptchaComponent = () => {
    return(
      <ReCAPTCHA
        sitekey={RECAPTCHA_PUBLIC_KEY as string}
        onChange={(newToken: string|null) => setRecaptchaToken(newToken)}
      />
    )
  }

  return(
    <>
      {
        !success ?
          <form action="#" id="contact-form" onSubmit={onSubmit} className="pt-5">
            <div className="row">
              <div className="col-md-4 mb-3">
                <label htmlFor="lastName" className="required-field">{t('name')}</label>
                <input type="text"
                       className={errors.lastName ? "form-control is-invalid" : "form-control"}
                       id="lastName"
                       placeholder={t('name')}
                       {...register("lastName", {required: true})}
                />
                {errors.lastName?.type === "required" &&
                  <span className="invalid-feedback">{t("fields_required")}</span>}
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="firstName" className="required-field">{t('firstname')}</label>
                <input type="text"
                       className={errors.firstName ? "form-control is-invalid" : "form-control"}
                       id="lastName"
                       placeholder={t('firstname')}
                       {...register("firstName", {required: true})}
                />
                {errors.firstName?.type === "required" &&
                  <span className="invalid-feedback">{t("fields_required")}</span>}
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="company" className="required-field">{t('company')}</label>
                <input type="text"
                       className={errors.company ? "form-control is-invalid" : "form-control"}
                       id="company"
                       placeholder={t('company')}
                       {...register("company", {required: true})}
                />
                {errors.company?.type === "required" &&
                  <span className="invalid-feedback">{t("fields_required")}</span>}
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="email" className="required-field">{t('email')}</label>
                <input type="text"
                       className={errors.email ? "form-control is-invalid" : "form-control"}
                       id="email"
                       placeholder={t('email')}
                       {...register("email", {required: true})}
                />
                {errors.email?.type === "required" &&
                  <span className="invalid-feedback">{t("fields_required")}</span>}
              </div>

              <div className="col-md-4 mb-3">
                <label htmlFor="jobFunction" className="required-field">{t('function')}</label>
                <input type="text"
                       className={errors.jobFunction ? "form-control is-invalid" : "form-control"}
                       id="jobFunction"
                       placeholder={t('function')}
                       {...register("jobFunction", {required: true})}
                />
                {errors.jobFunction?.type === "required" &&
                  <span className="invalid-feedback">{t("fields_required")}</span>}
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="street" className="required-field">{t('address')}</label>
                <input type="text"
                       className={errors.street ? "form-control is-invalid" : "form-control"}
                       id="lastName"
                       placeholder={t('address')}
                       {...register("street", {required: true})}
                />
                {errors.street?.type === "required" &&
                  <span className="invalid-feedback">{t("fields_required")}</span>}
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="zipcode" className="required-field">{t('zip')}</label>
                <input type="text"
                       className={errors.zipcode ? "form-control is-invalid" : "form-control"}
                       id="zipcode"
                       placeholder={t('zip')}
                       {...register("zipcode", {required: true})}
                />
                {errors.zipcode?.type === "required" &&
                  <span className="invalid-feedback">{t("fields_required")}</span>}
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="city" className="required-field">{t('city')}</label>
                <input type="text"
                       className={errors.city ? "form-control is-invalid" : "form-control"}
                       id="city"
                       placeholder={t('city')}
                       {...register("city", {required: true})}
                />
                {errors.city?.type === "required" &&
                  <span className="invalid-feedback">{t("fields_required")}</span>}
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="country" className="required-field">{t('country')}</label>
                <input type="text"
                       className={errors.country ? "form-control is-invalid" : "form-control"}
                       id="country"
                       placeholder={t('country')}
                       {...register("country", {required: true})}
                />
                {errors.country?.type === "required" &&
                  <span className="invalid-feedback">{t("fields_required")}</span>}
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="phone" className="required-field">{t('phone')}</label>
                <input type="text"
                       className={errors.phone ? "form-control is-invalid" : "form-control"}
                       id="phone"
                       placeholder={t('phone')}
                       {...register("phone", {required: true})}
                />
                {errors.phone?.type === "required" &&
                  <span className="invalid-feedback">{t("fields_required")}</span>}
              </div>
              <div className="col-md-8 mb-3">
                <label className="hidden-visible">{ t('i_accept_condition')}</label>
                <div className="box box-check box-inline-form">
                  <label className="form-check">
                    <input id="hasAcceptedConditions"
                           type="checkbox"
                           defaultChecked={false}
                           {...register('hasAcceptedConditions', {required:true})}
                           className={`form-check-input ${errors.hasAcceptedConditions ? 'is-invalid' : ''}`}/>
                    <b className={`border-oncheck form-control ${errors.hasAcceptedConditions ? 'is-invalid' : ''}`}/>
                    <span className="form-check-label"> { t('i_accept_condition')}</span>
                  </label>
                </div>
                {errors.hasAcceptedConditions?.type === "required" &&
                  <span className="invalid-feedback">{t("fields_required")}</span>}
              </div>
              <div className="col-md-12 mb-3">
                <label htmlFor="message" className="required-field block">{t('message')}</label>
                <textarea
                  rows={4}
                  className={errors.message ? "form-control is-invalid" : "form-control"}
                  id="message"
                  placeholder={t('message')}
                  {... register("message", {required: true})}/>
                {errors.message && <span className="invalid-feedback">{t("fields_required")}</span>}
              </div>
            </div>
            <div className="col-md-12 mb-3 align-items-center py-3">
              <div className="row width100 nopadding nomargin">
                <div className="col-md-6 mb-3 col-sm-12 pb-3 nopaddingl">
                  { recaptchaComponent() }
                </div>
                <div className="col-md-6 mb-3 col-sm-12 d-flex nopaddingr justify-content-end align-items-center">
                  <button className="btn btn-primary rounded submit-btn text-white" type="submit">
                    { t("send")}
                  </button>
                </div>
              </div>
            </div>
          </form>
          :
          <div className="alert alert-success">{ t('contact_form_submitted_success')}</div>
      }
    </>
)
}

export default ContactForm;
